import Cookies from 'js-cookie';

// Storage utility to abstract storage implementation
const storage = {
  setItem: async (key, value) => {
    try {
      if (key === 'token') {
        // Store token in httpOnly cookie for security
        Cookies.set(key, value, { 
          expires: 7, // 7 days
          secure: process.env.NODE_ENV === 'production', // HTTPS only in production
          sameSite: 'strict' // CSRF protection
        });
      } else {
        // Store other data in localStorage for non-sensitive information
        localStorage.setItem(key, value);
      }
    } catch (error) {
      console.error('Error saving to storage:', error);
      throw error;
    }
  },

  getItem: async (key) => {
    try {
      if (key === 'token') {
        return Cookies.get(key);
      } else {
        return localStorage.getItem(key);
      }
    } catch (error) {
      console.error('Error reading from storage:', error);
      throw error;
    }
  },

  removeItem: async (key) => {
    try {
      if (key === 'token') {
        Cookies.remove(key);
      } else {
        localStorage.removeItem(key);
      }
    } catch (error) {
      console.error('Error removing from storage:', error);
      throw error;
    }
  },

  clear: async () => {
    try {
      // Clear cookies
      Cookies.remove('token');
      // Clear localStorage
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing storage:', error);
      throw error;
    }
  }
};

export default storage; 